import { Spacer } from '@engbers/components/spacer';
export const SpacerTastic = ({
  data
}) => {
  return <Spacer spacing={data.size} data-sentry-element="Spacer" data-sentry-component="SpacerTastic" data-sentry-source-file="index.tsx" />;
};